var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: 2,
    d: "M11 18.877l.883-.868C19.063 11.733 21 9.403 21 6.256c0-2.81-2.192-4.976-5.047-4.976-1.575 0-3.17.737-4.193 1.933L11 4.1l-.76-.887C9.216 2.017 7.622 1.28 6.047 1.28 3.192 1.28 1 3.447 1 6.256c0 3.147 1.937 5.477 9.16 11.794l.84.827z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0a8e9e4830a9b2a640da514330264faf.svg";
export { ForwardRef as ReactComponent };